import { createSelector } from 'reselect';
import selectors from '../../../selectors/selectors.js';

const contactId = (state) => state.leadModal.composerPhone.contactId;
const primaryContactId = (state) => (selectors.activeLead(state) || {}).primary_contact_id;
const activeLeadContacts = (state) => (selectors.activeLead(state) || {}).contacts;

const composerPhoneContactSelector = createSelector(contactId, primaryContactId, activeLeadContacts, (contactId, primaryContactId, activeLeadContacts) => {
  const contacts = activeLeadContacts || [];
  return contacts.find((item) => item.id === contactId) || contacts.find((item) => item.id === primaryContactId);
});

export default composerPhoneContactSelector;
